export function isUSDASpecies(species) {
  return ['guinea_pig', 'pig', 'sheep', 'piglet'].includes(species)
}
